// Constants
export const FC_NAME = 'Hairin';
export const COMPANY_NAME = 'Prudential';
export const SCRIPTED_AGENT_ID = 'agent_01jzqbwk0yf9vs71hrgbqxexfr';

export interface ScriptNode {
  id: string;
  type: 'greeting' | 'statement' | 'question' | 'closing' | 'decision';
  content: string;
  agentMessage: string;
  expectedResponse?: {
    positive?: string[];
    negative?: string[];
    neutral?: string[];
  };
  nextNodes?: {
    positive?: string;
    negative?: string;
    neutral?: string;
    default?: string;
  };
  isEnd?: boolean;
  backgroundColor?: string;
  requiresInput?: boolean;
  waitForResponse?: boolean;
}

export interface Script {
  id: string;
  name: string;
  description: string;
  startNode: string;
  nodes: Record<string, ScriptNode>;
  agentInfo?: {
    name: string;
    voiceId: string;
    avatar?: string;
  };
}

export const prudentialAnnualCheckInScriptThai: Script = {
  id: 'prudential-annual-checkin-thai',
  name: 'การตรวจสอบประจำปีแบบพิเศษ',
  description: 'สคริปต์การตรวจสอบกรมธรรม์ประจำปีของ Prudential พร้อมขั้นตอนการตัดสินใจ',
  startNode: '1',
  agentInfo: {
    name: 'Ploy',
    voiceId: 'ckdz71REaQKVx2gnOQjQ',
    avatar: 'https://dopmo1eihgbgm.cloudfront.net/67135d6f890cc59eb99e65f9/ai-headshot.webp'
  },
  nodes: {
    '1': {
      id: '1',
      type: 'greeting',
      content: 'คำทักทายและการแนะนำตัวเริ่มต้น',
      agentMessage: `สวัสดีค่ะ ดิฉันพลอย โทรมาจาก ${COMPANY_NAME} ในนามของที่ปรึกษาทางการเงินของคุณ คุณ${FC_NAME} ดิฉันอยากแจ้งให้ทราบว่าดิฉันเป็นผู้ช่วยเสมือนจริง และการโทรครั้งนี้จะถูกบันทึกเพื่อวัตถุประสงค์ในการฝึกอบรมและควบคุมคุณภาพ คุณสะดวกที่จะพูดคุยได้ไหมคะ?`,
      backgroundColor: '#d4edda',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['ได้', 'ค่ะ', 'ครับ', 'ได้เลย', 'พูดได้', 'สะดวก', 'มีเวลา'],
        negative: ['ไม่ได้', 'ไม่สะดวก', 'ยุ่ง', 'ไว้ทีหลัง', 'ไม่ว่าง'],
      },
      nextNodes: {
        positive: '2',
        negative: '7',
        neutral: '10',
        default: '2'
      }
    },
    '2': {
      id: '2',
      type: 'statement',
      content: 'อธิบายวัตถุประสงค์และถามเรื่องการติดต่อจาก FC',
      agentMessage: `เป็นเวลานานแล้วนะคะ/ครับ หวังว่าคุณจะสบายดี ดิฉัน/ผมโทรมาเพื่อดูว่าคุณสนใจที่จะพูดคุยเพื่อทบทวนและอัพเดทข้อมูลกรมธรรม์ของคุณ เพื่อวางแผนสำหรับเป้าหมายต่อไปของคุณไหมคะ/ครับ คุณสนใจที่จะให้คุณ${FC_NAME}ติดต่อกลับไปหาคุณไหมคะ/ครับ?`,
      backgroundColor: '#ffffff',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['สนใจ', 'ได้', 'ค่ะ', 'ครับ', 'โอเค', 'ดีเลย'],
        negative: ['ไม่สนใจ', 'ไม่ต้องการ', 'ไม่จำเป็น', 'ไม่เอา'],
      },
      nextNodes: {
        positive: '4',
        negative: '11',
        neutral: '11',
        default: '11'
      }
    },
    '3': {
      id: '3',
      type: 'statement',
      content: 'แก้ไขข้อกังวลและอธิบายกระบวนการ',
      agentMessage: `ดิฉัน/ผมเข้าใจว่าคุณอาจมีข้อกังวลด้วยเหตุผลต่างๆ คุณ${FC_NAME}จะทำงานร่วมกับคุณเพื่อทบทวนพอร์ตโฟลิโอปัจจุบันของคุณตามความต้องการของคุณ หรือหารือเรื่องการเสนอชื่อผู้รับผลประโยชน์สำหรับกรมธรรม์ของคุณ หากคุณพบว่ามันสมเหตุสมผล คุณ${FC_NAME}สามารถทำงานร่วมกับคุณได้ หากไม่เหมาะสม เราก็จะติดต่อกันต่อไปจนกว่าจะถึงเวลาที่เหมาะสมกว่า ดิฉัน/ผมขอจัดการให้คุณ${FC_NAME}ติดต่อกลับไปหาคุณเพื่อนัดหมายได้ไหมคะ/ครับ?`,
      backgroundColor: '#ffffff',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['ได้', 'โอเค', 'ค่ะ', 'ครับ', 'จัดการให้', 'ดีเลย'],
        negative: ['ไม่ได้', 'ไว้ทีหลัง', 'ยังไม่พร้อม'],
      },
      nextNodes: {
        positive: '4',
        negative: '9',
        default: '4'
      }
    },
    '4': {
      id: '4',
      type: 'statement',
      content: 'ยืนยันเวลาโทรกลับ',
      agentMessage: `ขอบคุณค่ะ/ครับ คุณ${FC_NAME}จะโทรกลับไปหาคุณภายใน 2 วันทำการ สะดวกไหมคะ/ครับ?`,
      backgroundColor: '#d4edda',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['ได้', 'โอเค', 'สะดวก', 'ค่ะ', 'ครับ', 'ดีเลย'],
        negative: ['ไม่ได้', 'เร็วไป', 'เปลี่ยนเวลา', 'ไว้ทีหลัง', 'ไม่สะดวก'],
      },
      nextNodes: {
        positive: '5',
        negative: '5',
        neutral: '5',
        default: '5'
      }
    },
    '5': {
      id: '5',
      type: 'question',
      content: 'ถามเวลาที่สะดวก',
      agentMessage: `เอ่อ ช่วงเวลาไหนที่สะดวกให้โทรกลับไปได้บ้างคะ/ครับ?`,
      backgroundColor: '#ffffff',
      requiresInput: true,
      waitForResponse: true,
      nextNodes: {
        default: '6'
      }
    },
    '6': {
      id: '6',
      type: 'closing',
      content: 'ปิดการสนทนาเชิงบวก',
      agentMessage: `ดีมากเลยค่ะ/ครับ คุณ${FC_NAME}จะติดต่อกลับไปหาคุณตามเวลาที่คุณบอกนะคะ/ครับ ขอบคุณสำหรับเวลาของคุณ และขอให้มีความสุขในวันนี้นะคะ/ครับ สวัสดีค่ะ/ครับ!`,
      backgroundColor: '#ffcccc',
      isEnd: true,
      requiresInput: false
    },
    '7': {
      id: '7',
      type: 'question',
      content: 'จัดการข้อเสนอการโทรกลับจาก FC',
      agentMessage: `อ๋อ.. ขอโทษที่รบกวนนะคะ/ครับ จะสะดวกไหมถ้าคุณ${FC_NAME}โทรกลับไปหาคุณทีหลังคะ/ครับ?`,
      backgroundColor: '#ffffcc',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['ได้', 'โอเค', 'ค่ะ', 'ครับ', 'ไว้วันอื่น'],
        negative: ['ไม่ต้อง', 'ไม่โทรมา', 'ไม่สนใจ'],
      },
      nextNodes: {
        positive: '5',
        negative: '8',
        default: '8'
      }
    },
    '8': {
      id: '8',
      type: 'closing',
      content: 'ปิดการสนทนาแบบกลางๆ',
      agentMessage: `อ๋อ โอเคค่ะ/ครับ ไม่เป็นไรค่ะ/ครับ ขอบคุณที่พูดคุยกับดิฉัน/ผมในวันนี้นะคะ/ครับ สวัสดีค่ะ/ครับ!`,
      backgroundColor: '#ffcccc',
      isEnd: true,
      requiresInput: false
    },
    '9': {
      id: '9',
      type: 'closing',
      content: 'ปิดการสนทนาแบบธรรมดา',
      agentMessage: `ขอบคุณค่ะ/ครับ และขอให้มีความสุขในวันนี้นะคะ/ครับ สวัสดีค่ะ/ครับ`,
      backgroundColor: '#ffcccc',
      isEnd: true,
      requiresInput: false
    },
    '10': {
      id: '10',
      type: 'closing',
      content: 'ปิดการสนทนาเนื่องจากปัญหาการได้ยิน',
      agentMessage: `ขอโทษนะคะ/ครับ ดิฉัน/ผมมีปัญหาในการได้ยินเสียงคุณ ดิฉัน/ผมจะโทรกลับไปหาคุณอีกครั้งในโอกาสหน้านะคะ/ครับ ขอให้มีความสุขในวันนี้นะคะ/ครับ สวัสดีค่ะ/ครับ!`,
      backgroundColor: '#ffcccc',
      isEnd: true,
      requiresInput: false
    },
    '11': {
      id: '11',
      type: 'statement',
      content: 'อธิบายการทำงานเป็นทีม',
      agentMessage: `ดิฉัน/ผมขอบคุณสำหรับคำถามของคุณนะคะ/ครับ คุณ${FC_NAME}และดิฉัน/ผมทำงานร่วมกันเป็นทีม เพื่อให้แน่ใจว่าคุณจะได้รับความสนใจอย่างทันท่วงที แนวทางของเราคือการมีประสิทธิภาพและตอบสนองได้เร็วที่สุดในการช่วยเหลือคุณ มั่นใจได้เลยว่าดิฉัน/ผมสามารถให้คุณ${FC_NAME}ติดต่อกลับไปหาคุณภายใน 2 วันทำการ คุณสนใจไหมคะ/ครับ?`,
      backgroundColor: '#ffffcc',
      requiresInput: true,
      waitForResponse: true,
      expectedResponse: {
        positive: ['สนใจ', 'ได้', 'โอเค', 'ค่ะ', 'ครับ'],
        negative: ['ไม่สนใจ', 'ไม่ต้องการ'],
      },
      nextNodes: {
        positive: '4',
        negative: '9',
        default: '4'
      }
    }
  }
};
